/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type HasPassengersOnBoardVehicleFragment = {
  __typename?: 'Vehicle'
  fccUpcomingWaypoints: Array<{
    __typename?: 'FccWaypoint'
    actions: Array<
      | {
          __typename: 'FccWaypointDeliveryAction'
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | { __typename: 'FccWaypointHubReturnAction' }
      | {
          __typename: 'FccWaypointPickupAction'
          trip: { __typename?: 'Trip'; id: string } | null
        }
      | { __typename: 'FccWaypointReallocationAction' }
    >
  }> | null
}

export const HasPassengersOnBoardVehicleFragmentDoc = gql`
    fragment HasPassengersOnBoardVehicle on Vehicle {
  fccUpcomingWaypoints {
    actions {
      __typename
      ... on FccWaypointPickupAction {
        trip {
          id
        }
      }
      ... on FccWaypointDeliveryAction {
        trip {
          id
        }
      }
    }
  }
}
    `
